export default "__VITE_ASSET__BBL1eBE1__"